import { format } from "../../libs/date.format";

const formattedStartEndTime = (start, end) => {
    const fullWeekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const first = new Date(start);
    const last = new Date(end);

    const startDate = `${fullWeekdays[first.getDay()]} ${format(first, "dS mmmm yyyy")}`;
    const endDate = `${fullWeekdays[last.getDay()]} ${format(last, "dS mmmm yyyy")}`;

    return ` ${startDate} - ${endDate} `;
};

export default formattedStartEndTime;
